import { render, staticRenderFns } from "./ServiceSettingTask.vue?vue&type=template&id=51a5dfbb&"
import script from "./ServiceSettingTask.vue?vue&type=script&lang=ts&"
export * from "./ServiceSettingTask.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports